import { useIntl } from "react-intl";
import { useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/AgentAction";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { Modal } from "../../common/Modal1";
import { EditAgentForm } from "./EditAgentForm";

export const EditAgentDialog = ({
  setSwalProps,
  agentId,
  oldNickname,
  isVisible,
  onClose,
}) => {
  const intl = useIntl();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const agentState = useSelector(({ agent }) => agent, shallowEqual);

  const saveValues = (queryParams) => {
    dispatch(actions.editAgentList(queryParams)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "editAgentSuccess" }),
          onConfirm: () => {
            formikRef.current.resetForm();
            dismissBtnRef.current.click();
            const queryParams = {
              action: "agentdetail",
              selagentid: agentId,
            };
            dispatch(actions.callAgentDetails(queryParams));
            onClose();
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <Modal
      modalId="editAgentModal"
      title={intl.formatMessage({ id: "editAgent" })}
      dismissBtnRef={dismissBtnRef}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className="p-3 custom-border-bottom">
        <EditAgentForm
          formikRef={formikRef}
          saveValues={saveValues}
          agentId={agentId}
          oldNickname={oldNickname}
        />
      </div>
      <div className="p-3 d-flex justify-content-end align-items-center">
        {agentState.actionsLoading && (
          <div
            className="spinner-border me-2"
            role="status"
            style={{ scale: "0.55" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        )}
        <button
          type="button"
          disabled={agentState.actionsLoading}
          className="btn btn-primary px-3"
          onClick={() => formikRef.current.submitForm()}
        >
          {intl.formatMessage({ id: "edit" })}
        </button>
      </div>
    </Modal>
  );
};
